import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import GalleryPage from './GalleryPage';
import BookingPage from './BookingPage';
import ReservationPage from './ReservationPage';
import RoomDetailPage from './RoomDetailPage';
import TennisCourtPage from './TennisCourtPage';
import TermsPage from './TermsPage';
import RodoPage from './RodoPage';
import Navigation from './components/Navigation';
import WebsiteMaintenancePage from './WebsiteMaintenancePage';
import { withQueryData } from '../../common/withQueryData';
import { usePropertyData } from '../../common/hooks/usePropertyId';
import { useDocumentBranding } from '../../common/hooks/useDocumentBranding';
import { shouldShowWebsiteMaintenance } from '../../common/websiteMaintenance';

/**
 * CustomerPageContent receives property from withQueryData and renders
 * Navigation plus all customer routes. Property is passed to Navigation
 * for logo and name.
 */
const CustomerPageContent = ({ data: property, reload }) => {
  useDocumentBranding(property);

  return (
    <>
      <Navigation property={property} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/rooms/:roomId" element={<RoomDetailPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/tennis" element={<TennisCourtPage />} />
        <Route path="/reservation/:reservationId/*" element={<ReservationPage />} />
        <Route path="/regulamin" element={<TermsPage />} />
        <Route path="/rodo" element={<RodoPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

const CustomerPageContentWithQueryData = withQueryData(CustomerPageContent);

/**
 * CustomerPage component handles routing for the customer-facing website.
 * Wraps content with withQueryData to load property; Navigation is rendered
 * once here and receives the property for logo and name.
 *
 * @component
 * @returns {React.Element} The rendered CustomerPage component with routes.
 */
const CustomerPage = () => {
  const propertyConfig = useSelector((state) => state.config.propertyConfig);
  const { queryData } = usePropertyData();

  if (shouldShowWebsiteMaintenance(propertyConfig)) {
    return <WebsiteMaintenancePage />;
  }

  return <CustomerPageContentWithQueryData queryData={queryData} />;
};

export default CustomerPage;

